module.exports = "../fonts/hotel_parking_icon.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hotel_parking_icon.svg
// module id = 443
// module chunks = 0